export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img className="animate" src="./img/about-img.webp" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
          We offer reliable Man and Van delivery alongside expert carpet and upholstery cleaning services.
           Whether you’re moving home, need items delivered, or want your carpets refreshed, we’re here to help. 
           With years of experience, affordable rates, and a friendly approach, customer satisfaction is always our priority.
          </p>
          <p className="hero--section-description">
          Our team is fully insured and equipped to handle all your moving and cleaning needs. We pride ourselves on our 
          professionalism, punctuality, and attention to detail. Contact us today for a free quote and let us take the 
          stress out of your next move or cleaning task!
          </p>
           <div className="hero-btn animate">
        <a className="btn btn-primary" href="https://wa.me/7359713227" target="_blank">Get a Quote</a>
        </div>
        </div>
      </div>
    </section>
  );
}
